import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";

// Project modules
import { formatTime } from "../../Helpers/helpers";
import { GameContext } from "../../Context/GameContext";
import ControlButtons from "../../Components/ControlButtons/ControlButtons";

/**
 * Winner
 * ------
 * Celebration screen shown when the team escapes.
 * Behaviour:
 * - Reads `timeTaken` and `remainingTime` from router location state.
 * - Decides whether to reset a single room or the whole campaign based on profile settings.
 */

// TYPES -------------------------------------------------------------
type WinnerLocationState = {
  timeTaken: number;
  remainingTime: number;
} | null;

// COMPONENT ---------------------------------------------------------
const Winner: React.FC = () => {
  /** CONTEXT ------------------------------------------------------- */
  const { teamName, resetRoomProgress, resetGame, profileSettings } =
    useContext(GameContext);

  /** DERIVED ------------------------------------------------------- */
  const location = useLocation();
  const { timeTaken = 0, remainingTime = 0 } =
    (location.state as WinnerLocationState) ?? {};
  const isSingleRoom = Boolean(profileSettings?.singleRoom);

  /** RENDER -------------------------------------------------------- */
  return (
    <div className="escape-room">
      <div id="escapeRoomContainer">
        <ControlButtons />

        <div className="room" id="winnersDontUseDrugs">
          <div className="winner-wrap">
            <div className="congrats" />

            {/* Stats card */}
            <div className="winner-stats-card">
              <div className="winner-stats">
                <h1 className="winner-title">Team “{teamName}”!</h1>

                <p>
                  You escaped the room in <b>{formatTime(timeTaken)}</b>
                </p>
                <p>
                  with <b>{formatTime(remainingTime)}</b> left on the timer.
                </p>

                <Link to="/">
                  <button
                    className="btn-blue"
                    style={{ marginTop: 8, marginBottom: 8 }}
                    onClick={isSingleRoom ? resetGame : resetRoomProgress}
                  >
                    End the challenge
                  </button>
                </Link>
              </div>
            </div>
          </div>
          {/* /winnerWrap */}
        </div>
      </div>
    </div>
  );
};

export default Winner;